// test634
(634 && 0);
